module.exports = __webpack_public_path__ + "images/apps/wxwork-58556200439540ccb9e90a6572bbcd51.png";